import React from "react";
import { createPortal } from "react-dom";

export default function SearchPin({ svgRoot, x, y, visible, zoom }) {
  if (!svgRoot) return null;
  if (x == null || y == null) return null;
  if (!visible) return null;

  return createPortal(
    <g id="search-pin" pointerEvents="none" transform={`translate(${x}, ${y})`}>
      <g id="search-pin-sprite" transform={`scale(${1 / (zoom || 1)})`}>
        <path
          d="M0,0 L13,-26 A15,15 0 1,0 -13,-26 Z"
          fill="#E53935"
          stroke="white"
          strokeWidth="1.8"
        />
        <circle cx="0" cy="-28" r="3.5" fill="white" />
      </g>
    </g>,
    svgRoot
  );
}
